import React from "react";

const Home = () => {
  return (
    <>
      <h2 className="text-4xl font-bold text-[#e2e8f0] mb-8 text-center relative orbitron">
        About
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>
      <div className="flex">
        <div className="text-start">
          <p className="text-base text-[#94a3b8] font-bold text-left philosopher-6">
            I am Jay Kolawala, a passionate FullStack Developer dedicated to
            crafting visually appealing, user-friendly, and accessible web
            experiences. With a focus on modern technologies and attention to
            pixel-perfect designs, I continuously strive to bring ideas to life
            on the web. My expertise lies in building responsive, intuitive
            interfaces that ensure seamless user experiences across all devices.
          </p>
          <p className="text-base text-[#94a3b8] font-bold mt-4 text-left philosopher-6">
            Beyond coding, I am an avid learner, constantly exploring new tools
            and frameworks to enhance my skills and stay ahead in this
            ever-evolving industry. I take pride in delivering clean, efficient
            code and collaborating effectively to turn complex problems into
            simple solutions.
          </p>
        </div>
      </div>
    </>
  );
};

export default Home;
